import type { PlatformService } from '@/shared/api'
import { colorKeyToken } from '@/shared/lib/color-key'

/**
 * `PlatformService.colorKey` без совпадения уезжает в акцент — свой fallback, отличный от
 * `companyColor` (серый): у `PlatformService.colorKey` нет значения `gray`
 * (`accent|blue|green|orange|violet`, `openapi/components/schemas/platform.yaml`), а серый
 * для сервиса платформы и не нужен — плитка «текущего» сервиса красится в акцент явно
 * (`PlatformSwitcher.module.css`, `.currentAvatar`), а не через эту функцию.
 */
const FALLBACK = 'var(--accent)'

export function serviceColor(service: Pick<PlatformService, 'colorKey'>): string {
  return colorKeyToken(service.colorKey, FALLBACK)
}
